import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { PageLayouts } from "components/common";
import { Grid } from "@mui/material";
import FinancialStatementsList from "./list";
import useAnnualAccountPermissions from "./usePermissions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const FinancialStatementReport: React.FC = (props) => {
  const { getHasAnnualAccountDocumentPermission } = useAnnualAccountPermissions();
  return (
    <PageLayouts.DashboardLayout
      entityKey={0}
      hasPermissions={getHasAnnualAccountDocumentPermission()}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.FinancialStatements)}
    >
      <Grid container item>
        <FinancialStatementsList />
      </Grid>
    </PageLayouts.DashboardLayout>
  );
};

export default FinancialStatementReport;
